







































































































import Vue from 'vue';
import LearningTools from '@/tools/learning';
import BbTools from '@/tools/bluebird';
import UserTools from '@/tools/user';
import sampleSize from 'lodash.samplesize';
import shuffle from 'lodash.shuffle';
import uniq from 'lodash.uniq';
import {
  FirebaseLesson,
  Phrase,
  Quiz,
  QuizPhrase,
  RapidTestResponse,
} from '@/store/types';
import ActivityCompleted from '@/components/activity/ActivityCompleted.vue';
import QuizListening from '@/components/quizzes/QuizListening.vue';
import RoutePaths from '@/router/route_paths';
import QuizReading from '@/components/quizzes/QuizReading.vue';
import Quiz4Answers from '@/components/quizzes/Quiz4Answers.vue';
import QuizPhraseMatch from '@/components/quizzes/QuizPhraseMatch.vue';
import QuizTranslation from '@/components/quizzes/QuizTranslation.vue';
import QuizSpelling from '@/components/quizzes/QuizSpelling.vue';
import uniqby from 'lodash.uniqby';

export default Vue.extend({
  name: 'Quizzes',
  components: {
    'activity-completed': ActivityCompleted,
    listening: QuizListening,
    reading: QuizReading,
    'quiz-4answers': Quiz4Answers,
    phrasematch: QuizPhraseMatch,
    translation: QuizTranslation,
    spelling: QuizSpelling,
  },
  props: {
    isRapidTest: Boolean,
  },
  data() {
    return {
      activityIndex: 0,
      quizData: new Array<QuizPhrase>(),
      scores: new Array<number>(),
      averageScore: 0,
      quizCompleted: false,
      rapidTestQuizPhrase: null as QuizPhrase | null,
    };
  },
  async mounted(): Promise<void> {
    if (!this.isRapidTest) {
      const lessonStored = this.$store.state.userLessons
        .find((lesson: FirebaseLesson) => LearningTools.getFirebaseLessonName(this.$store)
          === LearningTools.getFirebaseLessonName(this.$store, lesson.lang_l, lesson.lesson_id));
      if (lessonStored) {
        await UserTools.updateLessonRecord(this.$store,
          LearningTools.getFirebaseLessonName(this.$store));
      } else {
        await UserTools.createLessonRecord(this.$store,
          LearningTools.getFirebaseLessonName(this.$store));
        await LearningTools.loadLessons(this.$store, this.$store.state.langI,
          this.$store.state.langL, this.$store.state.level.obj_id,
          this.$store.state.unit.unit, this.$store.state.lesson.id);
      }

      this.generateQuizData();
    } else {
      this.$store.commit('setRapidTestSID', BbTools.generateRandomString(26));
      const rapidTestPhrases = await LearningTools.getRapidTestPhrases(this.$store,
        this.$store.state.langI, this.$store.state.langL,
        this.$store.state.rapidTestSID, this.$store.state.firebaseToken);

      this.generateRapidTestQuizData(rapidTestPhrases?.data);
    }

    this.$store.commit('setMainLoading', false);
  },
  computed: {
    originalPhrases(): Array<Phrase> {
      if (this.isRapidTest) {
        return [];
      }
      if (this.$store.state.personalizedCourse || (this.$store.state.levelDaily
        && this.$store.state.level.id === LearningTools.LEVEL_DAILY_LESSONS)) {
        return this.$store.state.phrases;
      }
      return this.$store.state.phrases.filter((item: Phrase) => item.lesson_id
        === this.$store.state.lesson.id);
    },
    quizPhrase(): QuizPhrase | null {
      if (this.isRapidTest) {
        return this.rapidTestQuizPhrase;
      }
      if (this.activityIndex >= 0 && this.activityIndex < this.quizData.length) {
        return this.quizData[this.activityIndex];
      }
      return null;
    },
    quizTitle(): string {
      switch (this.quizPhrase!.quizType) {
        case LearningTools.QUIZ_LISTENING.id: return this.$store.state.tr.QuizListening;
        case LearningTools.QUIZ_READING.id: return this.$store.state.tr.QuizReading;
        case LearningTools.QUIZ_AUDIO_MATCH1.id: return this.$store.state.tr.QuizAudioMatch1;
        case LearningTools.QUIZ_AUDIO_MATCH2.id: return this.$store.state.tr.QuizAudioMatch2;
        case LearningTools.QUIZ_PHRASE_MATCH.id: return this.$store.state.tr.QuizPhraseMatch;
        case LearningTools.QUIZ_PHRASE_MATCH2.id:
          return `${this.$store.state.tr.QuizPhraseMatch} 2`;
        case LearningTools.QUIZ_TRANSLATION1.id: return this.$store.state.tr.QuizTranslation1;
        case LearningTools.QUIZ_TRANSLATION2.id: return this.$store.state.tr.QuizTranslation2;
        case LearningTools.QUIZ_SPELLING.id: return this.$store.state.tr.QuizSpelling;
        default: return '';
      }
    },
    LearningTools(): any {
      return LearningTools;
    },
  },
  methods: {
    onBack() {
      this.$store.commit('setLesson', null);
      this.$router.push({
        path: RoutePaths.LESSONS,
        query: {
          noInit: 'true',
        },
      });
    },
    /* eslint-disable @typescript-eslint/camelcase */
    generateRapidTestQuizData(phraseData: RapidTestResponse): void {
      const { question, QzType, answers }: {
        question: RapidTestItem;
        QzType: RapidTestQzType;
        answers: Array<RapidTestItem>;
      } = phraseData;

      let formatedObj = {} as QuizPhrase;
      if (QzType?.name === LearningTools.QUIZ_PHRASE_MATCH.label) {
        formatedObj = {
          choices: question.map((q) => ({
            ...q,
            native_word: q.word,
            audio: q.path_to_audio,
          })),
          nativeChoices: answers.map((a) => ({
            ...a,
            native_word: a.word,
          })),
        };
        [formatedObj.phrase] = formatedObj.choices;
        formatedObj.quizType = LearningTools.QUIZ_PHRASE_MATCH.id;
      } else {
        formatedObj = {
          phrase: {
            audio: question?.path_to_audio,
            bbImage: question?.path_to_word_image,
            word_image: question?.path_to_word_image,
            word: question?.word,
          },
          wordWithoutSpelling: question?.word,
          choices: [],
        };
        switch (QzType?.name) {
          case LearningTools.QUIZ_LISTENING.label:
            formatedObj.quizType = LearningTools.QUIZ_LISTENING.id;
            break;
          case LearningTools.QUIZ_READING.label:
            formatedObj.quizType = LearningTools.QUIZ_READING.id;
            break;
          case LearningTools.QUIZ_SPELLING.label:
            formatedObj.quizType = LearningTools.QUIZ_SPELLING.id;
            formatedObj.choicesString = question?.word_spell.split('');
            formatedObj.phraseAnswer = question?.word_spell.split('');
            formatedObj.wordWithoutSpelling = `\u200E${question?.word}`;
            formatedObj.correctWords = -1;
            break;
          case LearningTools.QUIZ_AUDIO_MATCH1.label:
            formatedObj.quizType = LearningTools.QUIZ_AUDIO_MATCH1.id;
            break;
          case LearningTools.QUIZ_AUDIO_MATCH2.label:
            formatedObj.quizType = LearningTools.QUIZ_AUDIO_MATCH2.id;
            break;
          case LearningTools.QUIZ_TRANSLATION1.label:
            formatedObj.quizType = LearningTools.QUIZ_TRANSLATION1.id;
            break;
          case LearningTools.QUIZ_TRANSLATION2.label:
            formatedObj.quizType = LearningTools.QUIZ_TRANSLATION2.id;
            formatedObj.phrase.native_word = question?.word;
            formatedObj.phraseAnswer = Array.from(Array(question?.word_count).keys());
            formatedObj.correctWords = -1;
            formatedObj.choicesString = answers[0].native_word;
            break;
          default: console.error('Unknown quiz name', QzType?.name); // todo
        }
      }

      if (QzType?.name !== LearningTools.QUIZ_PHRASE_MATCH.label
        && QzType?.name !== LearningTools.QUIZ_TRANSLATION1.label
        && QzType?.name !== LearningTools.QUIZ_TRANSLATION2.label) {
        const uniqueAnswers = uniqby(answers, 'native_word');
        uniqueAnswers.forEach((answer) => {
          formatedObj.choices.push({
            id: answer.id,
            native_word: answer.native_word,
            audio: answer.path_to_audio,
            bbImage: answer.path_to_word_image,
            word_image: answer.path_to_word_image,
            word: answer.word || answer.native_word,
          });
        });
      }

      this.quizData = answers;
      this.rapidTestQuizPhrase = formatedObj;
    },
    /* eslint-enabled @typescript-eslint/camelcase */
    async onScoreResult(score: number) {
      if (this.isRapidTest) {
        return;
      }
      if (!this.scores[this.activityIndex] || score > this.scores[this.activityIndex]) {
        this.scores[this.activityIndex] = score;
      }
      this.averageScore = LearningTools.calculateAverageScore(this.scores);
    },
    async checkQuizEndOrNext(nextQuestionResponse: RapidTestResponse): Promise<void> {
      if (this.isRapidTest) {
        this.generateRapidTestQuizData(nextQuestionResponse.data);
      } else if (this.activityIndex === this.quizData.length - 1) {
        this.quizCompleted = true;
        UserTools.saveScore(this.averageScore, this.$store);
      } else if (this.quizPhrase && this.quizPhrase.quizType === -1) { // writing or pronunciation
        // fixme: for displaying Next button or autoplay
      } else {
        await BbTools.sleepCancelable(LearningTools.TO_START_PLAYING, this.$store);
        this.activityIndex += 1;
      }
    },
    generateQuizData(needSingleQuestion = false): void {
      const quizzesWithoutPhraseMatch = [
        LearningTools.QUIZ_LISTENING,
        LearningTools.QUIZ_READING,
        LearningTools.QUIZ_AUDIO_MATCH1,
        LearningTools.QUIZ_AUDIO_MATCH2,
        LearningTools.QUIZ_TRANSLATION2,
        LearningTools.QUIZ_SPELLING,
      ];

      if (!this.isRapidTest) {
        quizzesWithoutPhraseMatch.push(LearningTools.QUIZ_TRANSLATION1);
      }

      const quizzesAvailable = needSingleQuestion ? [
        ...quizzesWithoutPhraseMatch,
        LearningTools.QUIZ_PHRASE_MATCH,
        LearningTools.QUIZ_PHRASE_MATCH2,
      ] : quizzesWithoutPhraseMatch;

      const phrases = this.originalPhrases;
      const quizDataLength = needSingleQuestion ? 1 : phrases.length;
      const tempData = needSingleQuestion ? sampleSize(phrases, 1)
        : sampleSize(phrases, quizDataLength >= 10 ? quizDataLength - 4 : quizDataLength);
      const quizData: Array<QuizPhrase> = [];
      tempData.forEach((phrase: Phrase) => {
        // if you want to check just one quiz type - set it here like this:
        // const randomQuiz: Array<Quiz> = [LearningTools.QUIZ_READING];
        const randomQuiz: Array<Quiz> = sampleSize(quizzesAvailable, 1);
        const quizType = randomQuiz[0].id;
        if (quizType === LearningTools.QUIZ_TRANSLATION1.id
          || quizType === LearningTools.QUIZ_TRANSLATION2.id) {
          quizData.push(LearningTools.generateTranslationQuiz(this.$store,
            phrase, phrases, quizType));
        } else if (quizType === LearningTools.QUIZ_AUDIO_MATCH1.id
          || quizType === LearningTools.QUIZ_AUDIO_MATCH2.id
          || quizType === LearningTools.QUIZ_LISTENING.id
          || quizType === LearningTools.QUIZ_READING.id) {
          quizData.push(this.generateQuizPhrase(phrase, phrases, quizType));
        } else if (quizType === LearningTools.QUIZ_SPELLING.id) {
          quizData.push(LearningTools.generateQuizSpellingData(this.$store, phrase));
        }
      });

      const remainingPhrases = phrases.filter((phrase: Phrase) => tempData.indexOf(phrase) === -1);
      if (remainingPhrases.length >= 4) {
        quizData.push(this.generatePhraseMatchData(sampleSize(remainingPhrases, 4)));
      } else if (remainingPhrases.length >= 2) {
        quizData.push(this.generatePhraseMatchData(sampleSize(remainingPhrases, 2)));
      }

      this.quizData = shuffle(quizData);
      this.scores = new Array<number>(quizData.length);
    },
    generatePhraseMatchData(phrases: Array<Phrase>): QuizPhrase {
      return {
        phrase: null,
        phraseAnswer: [''],
        wordWithoutSpelling: '',
        quizType: Math.random() > 0.5
          ? LearningTools.QUIZ_PHRASE_MATCH.id : LearningTools.QUIZ_PHRASE_MATCH2.id,
        nativeChoices: shuffle(phrases),
        correctWords: -1,
        choices: phrases,
        choicesString: [],
        score: 100,
        wrongAnswerPenalty: Math.floor(100 / phrases.length),
      };
    },
    generateQuizPhrase(phrase: Phrase, origPhrases: Array<Phrase>, quizType: number): QuizPhrase {
      let choices = [phrase];
      let wrongAnswers = 1;
      if (quizType === LearningTools.QUIZ_AUDIO_MATCH1.id
        || quizType === LearningTools.QUIZ_AUDIO_MATCH2.id) {
        wrongAnswers = 2;
      }
      const phrases: Array<Phrase> = [];
      // remove phrases.word duplicates
      origPhrases.forEach((origPhrase: Phrase) => {
        if (!phrases.find((ph: Phrase) => ph.word === origPhrase.word)) {
          phrases.push({ ...origPhrase });
        }
      });
      if (phrases.length <= 2) {
        // number of wrong answers = number of all phrases minus one which is correct
        wrongAnswers = phrases.length - 1;
      }
      if (wrongAnswers < 0) {
        wrongAnswers = 0;
      }
      while (choices.find((item) => item.word === phrase.word)) {
        choices = sampleSize(phrases, wrongAnswers);
        // now remove duplicates of phrase.word
        const arr = [phrase];
        for (let i = 0; i < choices.length; i += 1) {
          arr.push(choices[i]);
        }
        if (uniq(arr).length < choices.length + 1) {
          // recreate the array because the size was reduced after _.uniq method
          choices = [phrase];
        }
      }
      choices.push(phrase);
      choices = shuffle(choices);
      return {
        phrase,
        quizType,
        choices,
        choicesString: [],
        phraseAnswer: [''],
        wordWithoutSpelling: '',
        correctWords: -1,
        score: 100,
        nativeChoices: [],
        wrongAnswerPenalty: Math.floor(100 / choices.length),
      } as QuizPhrase;
    },
  },
});

